






















































import {
    computed,
    defineComponent,
} from '@vue/composition-api';
import { SdsIcon } from '@superbet-group/web.lib.ui-components';
import { WikiPath } from '@modules/wiki/WikiPath';
import { Link } from '@src/app/router/constants/Link';
import { getConfig } from '@superbet-group/web.lib.config';
import { Country } from '@superbet-group/web.types';
import {
    useVuexStore,
    isMobileLayout,
} from '@superbet-group/web.lib.vue-utilities';
import helpUiStoreIndex from '@store/modules/ui/help/helpIndex';
import StaticLink from '@shared/components/StaticLink.vue';
import SdsPageHeader from '@shared/components/pageHeader/SdsPageHeader.vue';

type Option = {
    kind?: 'Wiki',
    label: string;
    tag: string;
    path?: boolean |
        string | {
            href: string;
            target: string;
        };
};

export default defineComponent({
    name: 'HelpAndSupportPage',
    setup() {
        const helpUiStore = useVuexStore<typeof helpUiStoreIndex>('ui/help');
        const showHelp = helpUiStore.action('showHelp');

        const section1: Option[] = [
            {
                tag: 'faq',
                label: 'FAQ',
                path: {
                    href: getConfig().countrySpecific.footer.faqPage,
                    target: '_blank',
                },
            },
            {
                kind: 'Wiki',
                tag: 'payments',
                label: 'payment methods',
                path: WikiPath.PaymentMethods,
            },
            {
                tag: 'shops',
                label: 'shops',
                path: Link.App.Shops,
            },
            getConfig().countrySpecific.country !== Country.Be
                ? {
                    kind: 'Wiki',
                    tag: 'about-us',
                    label: 'about us',
                    path: WikiPath.AboutUs,
                }
                : {
                    tag: 'about-us',
                    label: 'about us',
                    path: {
                        href: `https://corporate.napoleonsportsandcasino.be/${getConfig().appLocale.languageCode}`,
                        target: '_blank',
                    },
                },
        ];

        const section2: Option[] = [
            {
                kind: 'Wiki',
                tag: 'privacy',
                label: 'privacy policy',
                path: WikiPath.PrivacyPolicy,
            },
            {
                kind: 'Wiki',
                tag: 'responsible-gaming',
                label: 'responsible gaming',
                path: WikiPath.ResponsibleGaming,
            },
            {
                kind: 'Wiki',
                tag: 'terms-and-conditions',
                label: 'Terms and Conditions',
                path: WikiPath.TermsAndConditions,
            },
            {
                kind: 'Wiki',
                tag: 'regulations',
                label: 'regulations',
                path: (WikiPath.GameRules || WikiPath.BettingAndGameRules),
            },
        ];

        const section3: Option[] = [
            {
                kind: 'Wiki',
                tag: 'contact',
                label: 'contact methods',
                path: WikiPath.Help,
            },
        ];

        return {
            showHelp,
            isMobile: computed(() => isMobileLayout()),
            URLs: {
                section1: section1.filter((option) => option.path),
                section2: section2.filter((option) => option.path),
                section3: section3.filter((option) => option.path),
            },
            getComponent: function getComponent(item: Option) {
                if (item.kind === 'Wiki') {
                    return StaticLink;
                } else if (item.path?.href) {
                    return 'a';
                } else {
                    return 'router-link';
                }
            },
        };
    },
    components: {
        SdsIcon,
        SdsPageHeader,
    },
});
